// @flow
import { createAction } from 'redux-actions';
import {
    ADD_ALERT, ADD_CONFIRM, REMOVE_ALERT, REMOVE_CONFIRM,
} from './constants';


export const addAlert = createAction(
    ADD_ALERT,
    (executionId: string, message: string, title?: string, actionLabel: ?string, size: ?string) => ({
        executionId, message, title, actionLabel, size,
    }),
);
export const addConfirm = createAction(
    ADD_CONFIRM,
    (executionId: string, message: string, key: string, actions: {
        [string]: {
            label: string,
            type: 'positive' | 'negative',
        }
    }, title?: string, size: ?string) => ({
        executionId, message, actions, title, size, key,
    }),
);

export const removeAlert = createAction(REMOVE_ALERT);
export const removeConfirm = createAction(REMOVE_CONFIRM);
